import _regeneratorRuntime from "/home/denis/workspace/smartheat/pump-services/node_modules/babel-preset-react-app/node_modules/@babel/runtime/regenerator";
import _asyncToGenerator from "/home/denis/workspace/smartheat/pump-services/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/asyncToGenerator";
import _slicedToArray from "/home/denis/workspace/smartheat/pump-services/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/slicedToArray";
import _styled from "styled-components";
import React, { useState } from "react";
import { useHistory } from "react-router-dom";
import { ReactComponent as SuccessIcon } from "@svgr/webpack?-svgo,+titleProp,+ref!@smartheat/common/svg/success.svg";
import { ReactComponent as ShowerIcon } from "@svgr/webpack?-svgo,+titleProp,+ref!@smartheat/common/svg/menu/hotel-shower-head.svg";
import { ReactComponent as FireIcon } from "@svgr/webpack?-svgo,+titleProp,+ref!@smartheat/common/svg/fire.svg";
import { ReactComponent as SnowIcon } from "@svgr/webpack?-svgo,+titleProp,+ref!@smartheat/common/svg/snow.svg";
import { usePathCreator } from "../Config/useLinkCreator";
import { Header } from "../Header/Header";
import { ModeRow } from "./ModeRow";
import { useSetRegisterMutation } from "../DeviceData/useSetRegisterMutation";
import { useRegistersSubscription } from "../DeviceData/useRegistersSubscription";
import { useRegisterConfigQuery } from "../DeviceData/useRegisterConfigQuery";
import { useRegSlot, useRegister } from "../hooks/useRegister";

var Container = _styled.div.withConfig({
  displayName: "Hw2ModePage__Container",
  componentId: "sc-1i4aryr-0"
})(["display:flex;flex-direction:column;"]);

var Title = _styled.div.withConfig({
  displayName: "Hw2ModePage__Title",
  componentId: "sc-1i4aryr-1"
})(["margin-top:60px;font-size:24px;text-align:center;padding:0 40px;"]);

var ModesContainer = _styled.div.withConfig({
  displayName: "Hw2ModePage__ModesContainer",
  componentId: "sc-1i4aryr-2"
})(["display:flex;flex:1;flex-direction:column;align-items:center;padding-top:30px;"]);

var allRegisters = ["t3", "t3_cold", "t1"];
export function ModePage() {
  var pathCreator = usePathCreator();
  var backTo = pathCreator("/");

  var _useRegistersSubscrip = useRegistersSubscription(allRegisters),
      registersData = _useRegistersSubscrip.registersData;

  var registersConfig = useRegisterConfigQuery(allRegisters);
  var t3Heat = useRegSlot("t3", registersData, registersConfig);
  var t3Chill = useRegSlot("t3_cold", registersData, registersConfig);
  var t1 = useRegSlot("t1", registersData, registersConfig);

  if (t3Heat.isDefined && t3Chill.isDefined && t1.isDefined) {
    return /*#__PURE__*/React.createElement(ModePageContent, {
      backTo: backTo,
      t3Heat: t3Heat,
      t3Chill: t3Chill,
      t1: t1
    });
  }

  return /*#__PURE__*/React.createElement(Container, null, /*#__PURE__*/React.createElement(Header, {
    backTo: backTo
  }), /*#__PURE__*/React.createElement(Title, null, "\u0417\u0430\u0433\u0440\u0443\u0437\u043A\u0430 \u0434\u0430\u043D\u043D\u044B\u0445..."));
}

function ModePageContent(_ref) {
  var backTo = _ref.backTo,
      t3Heat = _ref.t3Heat,
      t3Chill = _ref.t3Chill,
      t1 = _ref.t1;

  var _useSetRegisterMutati = useSetRegisterMutation(),
      _useSetRegisterMutati2 = _slicedToArray(_useSetRegisterMutati, 1),
      setRegister = _useSetRegisterMutati2[0];

  var history = useHistory();

  var _useState = useState(function () {
    return Math.round(t3Heat.value);
  }),
      _useState2 = _slicedToArray(_useState, 2),
      heatTemp = _useState2[0],
      setHeatTemp = _useState2[1];

  var _useState3 = useState(function () {
    return Math.round(t3Chill.value);
  }),
      _useState4 = _slicedToArray(_useState3, 2),
      chillTemp = _useState4[0],
      setChillTemp = _useState4[1];

  var _useState5 = useState(function () {
    return Math.round(t1.value);
  }),
      _useState6 = _slicedToArray(_useState5, 2),
      hwsTemp = _useState6[0],
      setHWSTemp = _useState6[1];

  var handleSaveClick = /*#__PURE__*/function () {
    var _ref2 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee() {
      return _regeneratorRuntime.wrap(function _callee$(_context) {
        while (1) {
          switch (_context.prev = _context.next) {
            case 0:
              if (heatTemp != t3Heat.value) {
                t3Heat.setValue(heatTemp);
              }

              if (chillTemp != t3Chill.value) {
                t3Chill.setValue(chillTemp);
              }

              if (hwsTemp != t1.value) {
                t1.setValue(hwsTemp);
              }

              history.push(backTo);

            case 4:
            case "end":
              return _context.stop();
          }
        }
      }, _callee);
    }));

    return function handleSaveClick() {
      return _ref2.apply(this, arguments);
    };
  }();

  return /*#__PURE__*/React.createElement(Container, null, /*#__PURE__*/React.createElement(Header, {
    backTo: backTo,
    actionIcon: SuccessIcon,
    onAction: handleSaveClick
  }), /*#__PURE__*/React.createElement(Title, null, "\u0423\u0441\u0442\u0430\u043D\u043E\u0432\u0438\u0442\u0435 \u043F\u0430\u0440\u0430\u043C\u0435\u0442\u0440\u044B \u0442\u0435\u043C\u043F\u0435\u0440\u0430\u0442\u0443\u0440\u044B"), /*#__PURE__*/React.createElement(ModesContainer, null, /*#__PURE__*/React.createElement(ModeRow, {
    icon: FireIcon,
    label: "Отопление",
    current: heatTemp,
    min: 10,
    max: 40,
    onChange: setHeatTemp
  }), /*#__PURE__*/React.createElement(ModeRow, {
    icon: SnowIcon,
    label: "Охлаждение",
    current: chillTemp,
    min: 5,
    max: 35,
    onChange: setChillTemp
  })));
}